import { createSelector } from 'reselect';

const selectTransporterSettings = (state: any) => state.transporterSettings;


export const selectTransporterSettingsCurrentItem = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.current);

export const selectTransporterSettingsListItems = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.list);

export const selectTransporterSettingsItemById = (itemId: any) =>
    createSelector(selectTransporterSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectTransporterSettingsQueryItems = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.query);

export const selectTransporterSettingsCreatedItem = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.create);

export const selectTransporterSettingsUpdatedItem = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.update);

export const selectTransporterSettingsReadItem = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.read);

export const selectTransporterSettingsDeletedItem = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.delete);

export const selectTransporterSettingsSearchedItems = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.search);

export const selectTransporterSettingsItemsCount = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.count);

export const selectTransporterSettingsItemsFilter = createSelector([selectTransporterSettings], (transporterSettings) => transporterSettings.filter);